export const GET_VIDEO_METRICS = "GET_VIDEO_METRICS";
export const GET_SHORTS_METRICS = "GET_SHORTS_METRICS";
export const GET_CHANNEL_METRICS = "GET_CHANNEL_METRICS";
export const GET_USER_METRICS = "GET_USER_METRICS";


export const GET_ALL_METRICS_COUNT = "GET_ALL_METRICS_COUNT"